import { updateKeyInStore } from 'App';
import {
  NonUsTrustStateValues,
  TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  | keyof NonUsTrustStateValues
  | keyof TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow
>[] = [
  {
    name: 'pleaseUploadTrustInstrument',
    label: 'Please upload Trust Instrument',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustBalanceSheet',
    label: 'Please upload Trust balance sheet',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTrustIncomeStatement',
    label: 'Please upload Trust Income Statement',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadDocumentReportingTheDistribution',
    label: 'Please upload document reporting the distribution',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.nonUsTrust.values.didYouReceivedACashOrPropertyDistributionFromTheTrust',
  },
];
